import { Console } from 'console';
import { TypeManager } from '../services/type-manager.service';
import { TYPE_MAP } from '../services/type-manager.service';

export function ManageType(aType: string) {
    return function _ManageType<T extends new(...args: any[]) => TypeManager>(constr: T) {
        console.log('registering type', aType);
        TYPE_MAP.set(aType, constr);
    };
}
